import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';
import { TriggerCategoryType } from '@/modules/HealthPlan/HealthPlan.types.ts';
import { AddTriggerFormValues } from '@/modules/HealthPlan/HealthPlanSetup/ComplexConfiguration/EnrollmentMatrix/ProcessingRuleModalV2/ProcessingRuleModal.types';

interface Params {
  defaultTriggerType: TriggerCategoryType;
}

const useAddTriggerForm = ({ defaultTriggerType }: Params) => {
  const methods = useForm<AddTriggerFormValues>({
    defaultValues: {
      triggerName: '',
      triggerType: defaultTriggerType,
    },
    resolver: getValidationResolver({
      triggerName: VALIDATORS.REQUIRED_STRING,
      triggerType: VALIDATORS.REQUIRED_STRING,
    }),
  });

  return { methods };
};

export default useAddTriggerForm;
